<template>
	<table class="table table-striped table-condensed">
		<tbody>
			<tr v-for="(item, index) in options" :key="index">
				<td style="width: 10px">
					<input type="radio" class="radio-inline" />
				</td>
				<td>{{ item }}</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
	export default {
		props: {
			options: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sd2000/import/components/exames-nao-importados/components/item-importation/components/options-worlab.vue